import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Experiencia", href: "#experiencia" },
  { label: "Soluciones", href: "#soluciones" },
  { label: "Ofertas", href: "#ofertas" },
  { label: "Opiniones", href: "#opiniones" },
];

export const Navbar = ({ onScrollTo }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    onScrollTo(href);
  };

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#F9F6F0]/80 border-b border-line/60"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-[1400px] mx-auto flex items-center justify-between px-6 md:px-10 h-20">
        <button
          data-testid="nav-logo"
          onClick={() => go("#top")}
          className="flex items-center gap-3"
        >
          <img
            src="/assets/brand/logo-icon.png"
            alt="Essentia Bellezza"
            className="h-10 w-auto md:h-11"
          />
          <span className="flex flex-col leading-none text-left">
            <span className="font-serif text-xl md:text-2xl text-ink">
              Essentia
            </span>
            <span className="text-[0.6rem] md:text-xs tracking-[0.3em] uppercase text-brand-soft">
              Bellezza
            </span>
          </span>
        </button>

        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              onClick={() => go(l.href)}
              className="text-sm text-ink/70 hover:text-accent transition-colors duration-300 relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-accent transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
        </div>

        <button
          data-testid="nav-cta"
          onClick={() => go("#ofertas")}
          className="hidden md:inline-flex items-center rounded-full bg-brand text-white px-6 py-2.5 text-sm hover:bg-accent transition-colors duration-300"
        >
          Comprar ahora
        </button>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-ink"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden bg-[#F9F6F0]/95 backdrop-blur-xl border-b border-line"
          >
            <div className="flex flex-col px-6 py-6 gap-5">
              {links.map((l) => (
                <button
                  key={l.href}
                  data-testid={`nav-mobile-${l.href.replace("#", "")}`}
                  onClick={() => go(l.href)}
                  className="text-left font-serif text-2xl text-ink"
                >
                  {l.label}
                </button>
              ))}
              <button
                data-testid="nav-mobile-cta"
                onClick={() => go("#ofertas")}
                className="mt-2 rounded-full bg-brand text-white px-6 py-3 text-sm"
              >
                Comprar ahora
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
